import { useState, useCallback } from 'react'
import useServiceCronJobsResources from '../../shared/resources/api/v1/admin/docker/useServiceCronJobsResources'

export default function useServiceCronJobsState(teamSlug, projectSlug, serviceSlug) {
  const [cronJobs, setCronJobs] = useState([])
  const [loading, setLoading] = useState(true)

  const {
    all,
    create,
    update,
    destroy,
  } = useServiceCronJobsResources(teamSlug, projectSlug, serviceSlug)

  const load = useCallback(() => {
    return all()
      .then((response) => setCronJobs(response.serviceCronJobs || []))
      .catch(() => setCronJobs([]))
      .finally(() => setLoading(false))
  }, [all])

  const refresh = useCallback(() => {
    return all()
      .then((response) => setCronJobs(response.serviceCronJobs || []))
      .catch(() => setCronJobs([]))
  }, [all])

  const createCronJob = useCallback((data) => {
    return create(data).then(() => refresh())
  }, [create, refresh])

  const updateCronJob = useCallback((id, data) => {
    return update(id, data).then(() => refresh())
  }, [update, refresh])

  const destroyCronJob = useCallback((id) => {
    return destroy(id).then(() => refresh())
  }, [destroy, refresh])

  return {
    cronJobs,
    loading,
    load,
    createCronJob,
    updateCronJob,
    destroyCronJob,
  }
}
